import { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import PaymentTable from '../../components/admin/PaymentTable';
import axios from 'axios';
import './AdminStyles.css';

// Используем относительный путь для админ панели
const API_URL = '/api';

function AdminPaymentsPage() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchPayments();
  }, [page]);

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('admin_token');
      
      const response = await axios.get(`${API_URL}/admin/payments?page=${page}&limit=50`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPayments(response.data.payments);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch payments:', err);
      setError('Не удалось загрузить платежи');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout currentPage="payments">
      <div className="admin-page">
        <div style={{ marginBottom: '32px' }}>
          <h1 className="text-3xl font-bold text-gray-900" style={{ marginBottom: '8px' }}>Платежи</h1>
          <p className="text-gray-500">История всех платежных транзакций</p>
        </div>

        <div className="admin-table">
          {error ? (
            <div className="empty-state">
              <p className="empty-state-title text-red-500">{error}</p>
              <button onClick={fetchPayments} className="admin-button admin-button-primary" style={{ marginTop: '16px' }}>
                Повторить
              </button>
            </div>
          ) : (
            <PaymentTable payments={payments} loading={loading} />
          )}
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminPaymentsPage;

